module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bgm),
      expression: "bgm"
    }],
    staticClass: "sound",
    on: {
      "click": function($event) {
        !_vm.soundMute ? _vm.stop() : _vm.play()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_sound.png"),
      "alt": "sound"
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.soundMute),
      expression: "!soundMute"
    }],
    attrs: {
      "src": require("../assets/image/icn_sound_on.png"),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.soundMute),
      expression: "soundMute"
    }],
    attrs: {
      "src": require("../assets/image/icn_sound_off.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('audio', {
    attrs: {
      "src": './static/sound/' + _vm.listSound[_vm.file],
      "preload": "auto"
    },
    on: {
      "ended": function($event) {
        _vm.onEndAudio(_vm.redirect)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4091e48e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audio.vue
// module id = 76
// module chunks = 0